import React, { useEffect, useState } from "react";

import { useAPIs } from "../../apis/APIsConfig";
import { Step1 } from "./Step1";
import { Step2 } from "./Step2";
import { Step3 } from "./Step3";
import { useGlobalStore } from "../../utils/global";

export function AddBenefit({ ...props }) {
  useAPIs();
  const { bpmsActive } = useGlobalStore(); 
  const [currentStep, setCurrentStep] = useState<number>(1);

  useEffect(() => {
    console.info(props.benefit);
  }, []);

  return (
    <>
      <div className="block pt-10 lg:pt-12 pb-32 md:pb-[480px]">
        <div className="block max-w-[792px]">
          <nav className="progress-bar mb-12">
            <a href="#!" className={`${currentStep === 1 ? "active" : ""}`}>
              <p>1. Descripción</p>
            </a>
            <a href="#!" className={`${currentStep === 2 ? "active" : ""}`}>
              <p>2. Condiciones &amp; Requisitos</p>
            </a>
            {!bpmsActive && (
              <a href="#!" className={`${currentStep === 3 ? "active" : ""}`}>
                <p>3. Subir Archivos</p>
              </a>
            )}
          </nav>
          {currentStep === 1 && (
            <Step1
              description={props.benefit.descripcion}
              cancel={() => props.cancel()}
              next={() => setCurrentStep(2)}
            />
          )}
          {currentStep === 2 && (
            <Step2
              conditions={props.benefit.condiciones}
              requirements={props.benefit.requisitos}
              prev={() => setCurrentStep(1)}
              next={() => {
                if (bpmsActive) {
                  // If BPMS is active, skip Step 3 and finish
                  props.cancel(); 
                } else {
                  setCurrentStep(3); // Go to Step 3 if BPMS is inactive
                }
              }}
            />
          )}
          {!bpmsActive && currentStep === 3 && (
            <Step3
              description={props.benefit.descripcion}
              codBeneficio={props.benefit.codBeneficio}
              prev={() => setCurrentStep(2)}
              cancel={() => props.cancel()}
            />
          )}
        </div>
      </div>
    </>
  );
}
